/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import { Link } from "./Link";
/**
 * TODO: Delete the `FooterLinkProps` type and just use `AppFooterLinkProps`.
 */

export var AppFooterLink = /*#__PURE__*/React.forwardRef(function AppFooterLink(props, ref) {
  var rel = props.target && props.target === '_blank' ? 'noopener noreferrer' : undefined;
  return /*#__PURE__*/React.createElement(Link, Object.assign({}, props, {
    ref: ref,
    rel: rel
  }));
});
/**
* **AppFooterLink** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/AppFooterLink) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-app-appfooterlink--default) |  [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=263:9) |
*
* AppFooterLink is used for navigation links within the AppFooter
*
* @example
* () => (
*  <AppFooterLink href="https://www.spotify.com/us/legal" target="_blank">
*    Legal
*  </AppFooterLink>
*);
*
*/

export default AppFooterLink;